import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size", "color"];
/**
 * DON'T EDIT THIS FILE DIRECTLY
 *
 * This file was auto-generated from an SVG icon.
 * Edit '/components/icons/template.js' to make changes
 * to the generated React component.
 *
 * See '/components/icons/README.stories.mdx' for details.
 */

import React, { forwardRef } from 'react';
import { useTheme } from 'styled-components';
import { getColorBlock } from 'utils/ui';
import BaseSvg from '../BaseSvg';
var TrendingIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$size = props.size,
    size = _props$size === void 0 ? 18 : _props$size,
    color = props.color,
    otherProps = _objectWithoutProperties(props, _excluded);
  var theme = useTheme();
  var fillColor = color ? getColorBlock(color, theme) : 'currentColor';

  // Unless the icon has an explicit ARIA label, we'll hide it visually
  var ariaHidden = !(otherProps['aria-label'] || otherProps['aria-labelledby']) || undefined;
  return /*#__PURE__*/React.createElement(BaseSvg, _extends({}, otherProps, {
    ref: ref,
    viewBox: "0 0 18 18",
    width: size,
    height: size,
    fill: fillColor,
    fillRule: "evenodd",
    clipRule: "evenodd",
    focusable: "false",
    "aria-hidden": ariaHidden
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,9l-1.793,-1.793l-4.5,4.5c-0.088,0.082 -0.181,0.152 -0.292,0.203c-0.284,0.129 -0.62,0.117 -0.894,-0.032c-0.085,-0.047 -0.158,-0.105 -0.228,-0.171l-2.293,-2.293l-4.293,4.293l-0.052,0.049c-0.132,0.106 -0.276,0.185 -0.442,0.221c-0.117,0.025 -0.237,0.03 -0.355,0.013c-0.409,-0.059 -0.747,-0.374 -0.835,-0.777c-0.02,-0.093 -0.027,-0.189 -0.02,-0.284c0.011,-0.167 0.066,-0.329 0.156,-0.47c0.039,-0.061 0.085,-0.113 0.134,-0.166l5,-5c0.088,-0.082 0.181,-0.152 0.292,-0.203c0.284,-0.129 0.62,-0.117 0.894,0.032c0.085,0.047 0.158,0.105 0.228,0.171l2.293,2.293l3.793,-3.793l-1.793,-1.793l5,0l0,5Z"
  }));
});
TrendingIcon.displayName = 'TrendingIcon';
export default TrendingIcon;